<template>
  <div>
    <el-dialog
      :title="isCreate ? '新增成员' : '编辑成员'"
      center
      :visible="true"
      @close="close"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="600px"
    >
      <el-form ref="form" label-width="150px" size="mini">
        <el-form-item label="名称：" prop="name">
          <el-select
            style="width: 140px"
            allow-create
            :disabled="!isCreate"
            v-model="form.name"
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in availableUsers"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
          <el-tooltip effect="dark" placement="top" style="margin-left: 10px">
            <div slot="content">
              一般直接选择本后台已存在的某个账号，对应账号将能够在本后台的相关页面中管理有自己参与的投票；针对不适合在本后台拥有账号的人士，就在这里填一个自定义名称即可
            </div>
            <span
              ><i class="el-icon-question" style="font-size: 1.5em"></i
            ></span>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="地址类型：" prop="addressType">
          <el-select
            style="width: 140px"
            v-model="form.addressType"
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in availableAddressTypes"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="通知地址：" prop="webhook">
          <el-input
            type="textarea"
            rows="5"
            v-model="form.address"
            clearable
            style="width: 350px"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取消</el-button>
        <el-button
          type="primary"
          @click="operation(isCreate ? 'add' : 'edit', form)"
          >保存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
const dialogutil = require("@/dialogutil");

// 本弹窗名称
const DialogName = "EditCorpMemberDialog";

export default {
  data() {
    return {
      isCreate: true,
      form: {
        name: "",
        address: "",
        addressType: "",
      },
      availableUsers: [],
      availableAddressTypes: [],
    };
  },
  components: {},
  async created() {
    await this.loadAvailableUsers();
    await this.loadAvailableAddressTypes();
    let value = dialogutil.getData(DialogName);

    this.isCreate = value.isCreate;
    if (!this.isCreate) {
      this.form = value.entry;
    }
  },

  methods: {
    async loadAvailableUsers() {
      this.availableUsers = [];
      let accounts = await this.$bizutil.loadAccounts();
      for (let account of accounts) {
        this.availableUsers.push(account.username);
      }
    },

    async loadAvailableAddressTypes() {
      this.availableAddressTypes = [];
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/corpflow/queryCorpMemberAddressTypes`,
          {},
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      let listInResponse = resData.data.types || [];
      for (let item of listInResponse) {
        this.availableAddressTypes.push(item);
      }
    },

    async operation(op, entry) {
      if (entry.addressType.length == 0) {
        this.$message.error("地址类型不能为空");
        return;
      }

      try {
        switch (op) {
          case "add": {
            // 弹确认框
            await this.$confirm(`确认新增成员：${entry.name}？`);
            break;
          }
          case "edit": {
            // 弹确认框
            await this.$confirm(`确认更新成员：${entry.name}？`);
            break;
          }
          default: {
            this.$message.error("未知操作：" + op);
            return;
          }
        }

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/corpflow/operationCorpMember`,
            {
              operation: op,
              entry: entry,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "操作成功",
          type: "success",
        });

        this.close();
      } catch (e) {}
    },
    close() {
      // 关闭当前对话框
      dialogutil.close(DialogName);
    },
  },
};
</script>